<template>
  <!-- 記名投票頁面 -->
  <div id="RecordNameVoting_main">
    <div class="main assembly-main">
      <div class="title">
        {{ topicDashboardData.assemblyTitle }}
      </div>
      <div>
        <div class="refreshTxt">
          統計最後更新時間：{{ refreshTime }}
        </div>
        <el-button
          type="success"
          icon="icon-refresh"
          size="mini"
          plain
          @click="refresh"
        >
          重新整理
        </el-button>
      </div>
    </div>
    <TopicDashboard
      :data="topicDashboardData"
      :total-area="totalArea"
      @refresh="refresh"
    />
    <VoteDashboard
      :data="voteDashboardData"
      :show-scan="topicDashboardData.topicStatus == 'voting'"
      :show-area="topicDashboardData.thresholdSetting ? topicDashboardData.thresholdSetting.isUseArea : false"
      @refresh="refresh"
    />
    <RecordNameVoteList
      :data="votesData"
      :topic-status="topicDashboardData.topicStatus"
      @refresh="refresh"
    />
  </div>
</template>
<script>
import TopicDashboard from './components/vote/TopicDashboard.vue'
import VoteDashboard from './components/vote/VoteDashboard.vue'
import RecordNameVoteList from './components/vote/RecordNameVoteList.vue'
export default {
  components: {
    TopicDashboard,
    VoteDashboard,
    RecordNameVoteList
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.timer)
    next()
  },
  data () {
    return {
      refreshTime: '',
      topicDashboardData: {}, // 議案資料
      voteDashboardData: [], // 投票資料
      votesData: [], // 投票票數資料
      timer: null,
      totalArea: 0 // 此議案總坪數
    }
  },
  mounted () {
    this.openRefreshTimer()
    this.getData()
    this.getVoteData()
    previousPage = { name: 'AssemblyRegister', params: { id: this.$route.params.id } } // header 上一頁路徑
  },
  methods: {
    getData () {
      apiUnitOwnerAssembly.Vote.GetVotingDashboardData(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId
        }
      ).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.topicDashboardData = res.data
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
      this.refreshTime = this.$newFormatDate(new Date())
    },
    getVoteData () {
      apiUnitOwnerAssembly.Vote.GetVotes(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId
        }
      ).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.voteDashboardData = []
          this.votesData = []
          this.totalArea = 0
          res.data.optionVotingResults.forEach(item => {
            if (item.thresholdRatio) { this.totalArea = this.totalArea + item.thresholdRatio.votesArea }
            this.voteDashboardData.push({
              id: item.id,
              content: item.content,
              votesArea: item.thresholdRatio ? item.thresholdRatio.votesArea : '-',
              votesNumber: item.votesNumber,
              votesRatio: item.thresholdRatio ? item.thresholdRatio.votesRatio : '-'
            })
            this.votesData.push({
              content: item.content,
              ballotPreviews: item.ballotPreviews
            })
          })
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    refresh () {
      this.getData()
      this.getVoteData()
    },
    // 刷新倒數計時器
    openRefreshTimer () {
      const time = 10000
      this.timer = setInterval(() => {
        this.refresh()
      }, time)
    }
  }
}
</script>
<style lang='sass' scoped>
#RecordNameVoting_main
  +mainLayer
  .assembly-main
    padding-top: 24px
    padding-bottom: 16px
    .title
      word-wrap: break-word
      color: $mainFontColor
      font-size: 25px
      font-weight: 600
      line-height: 35px
    .refreshTxt
      display: inline-block
      margin-top: 8px
      font-size: 17px
      color: $hintColor
      line-height: 24px
      margin-right: 8px
</style>
